import { AccessRoute } from 'ui/organisms/AccessRoutes/AccessRoutes.types';

type Translate = (key: string) => string;

export const getAccessRoutes = (t: Translate): AccessRoute[] => [
  {
    name: t('Platform'),
    desc: t('Search, screen and export company records from the web application.'),
    actions: [{ label: t('Open the platform'), href: 'https://platform.globaldatabase.com' }],
  },
  {
    name: 'API',
    desc: t('Query any company by registry ID. Documented endpoints, JSON responses, provenance on every value.'),
    actions: [{ label: t('Read the API docs'), href: '/api' }],
  },
  {
    name: t('Bulk data feeds'),
    desc: t('Full datasets and scheduled deltas, delivered to your warehouse on your cadence.'),
    actions: [{ label: t('Request a feed'), href: '/contact-us' }],
  },
  {
    name: 'CRM',
    desc: t(
      'HubSpot, Salesforce and Microsoft Dynamics. Registry fields matched onto your existing records by registration number.',
    ),
    actions: [
      { label: t('Install for HubSpot'), href: '/hubspot-data-enrichment' },
      { label: t('Install for Salesforce'), href: '/salesforce-integration' },
    ],
  },
  {
    name: 'MCP',
    desc: t('Connect the dataset to any MCP-compatible agent or tool, on the same key.'),
    actions: [{ label: t('MCP server'), href: 'https://mcp.globaldatabase.com/mcp' }],
  },
  {
    name: t('Assistant connectors'),
    desc: t('Pull registry data straight into your AI assistant, with the source attached to the answer.'),
    actions: [
      { label: t('Add to Claude'), href: '#' },
      { label: t('Add to ChatGPT'), href: '#' },
    ],
  },
  {
    name: 'Regis AI',
    desc: t(
      'Ask questions in natural language across the dataset and get sourced answers, in the platform or over the API.',
    ),
    actions: [
      { label: t('Regis AI'), href: '/regis' },
      { label: t('Regis API'), href: '/regis-api' },
    ],
  },
];
